<ng-template #modal let-c="close" let-d="dismiss">
  
  <div class="modal-header mh-primary">
    <h4 class="modal-title">Detalhes equipamento</h4>
  </div>

  <div class="modal-body">

    <div class="box-header text-center">

    
    </div>
   

    <div class="box-body">



      <form novalidate  style="padding-top: 10px;">

        <div class="form-row">

          <div class="col-md-3">
            <div class="position-relative form-group">
              <label for="">Tipo de Equipamento</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.tipoDeEquipamento.descricao" /> 
            </div>
          </div>

          <div class="col-md-3">
            <div class="position-relative form-group">
              <label for="">Classe equipamento</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.classeEquipamento.descricao" /> 
            </div>
          </div>


          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Código</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.nome" /> 
            </div>
          </div>


          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="">Grupo local</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.local.grupoLocalNivel1.nome" /> 
            </div>
          </div>

        </div>

        <div class="form-row">

          <div class="col-md-12">
            <div class="position-relative form-group">
              <label for="">Descricao</label>
              <input class="form-control text-left" type="text" disabled [value]="this.equipamento?.descricao" /> 
            </div>
          </div>

         

        </div>

        <div class="form-row">

          <div class="col-md-12">
            <div class="position-relative form-group">
              <label for="">Utilização</label>
              <input class="form-control text-left" type="text" disabled [value]="this.equipamento?.util" /> 
            </div>
          </div>


        


        </div>



        <div class="form-row">
          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="">Nº de série</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.numeroSerie" /> 
            </div>
          </div>
          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Nº patrimônio</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.numeroPatrimonio" /> 
            </div>
          </div>
          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Classe rotina</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.classe" /> 
            </div>
          </div>

          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="">Local</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.local.nome" 
              [title]="this.equipamento?.local.nome" /> 
            </div>
          </div>


        </div>


        <div class="form-row">

          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="">Modelo</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.modelo" /> 
            </div>
          </div>


          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Ano fabricação</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.anoFabricacao" /> 
            </div>
          </div>

          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Ano instalação</label>
              <input class="form-control  text-center" type="text" disabled [value]="this.equipamento?.anoInstalacao" /> 
            </div>
          </div>

         

        </div>


        <div class="form-row">

          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="">Largura</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.largura" /> 
            </div>
          </div>


          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Altura</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.altura" /> 
            </div>
          </div>




          <div class="col-md-2">
            <div class="position-relative form-group">
              <label for="">Comprimento</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.comprimento" /> 
            </div>
          </div>

          <div class="col-md-4">
            <div class="position-relative form-group">
              <label for="">Fabricante</label>
              <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.fabricante.nome" /> 
            </div>
          </div>



        </div>

       
        <section *ngIf="this.equipamento?.tipoDeEquipamentoId > 1">

          <p class="title-divider fb mt-3 mb-3"><span> {{this.equipamento?.tipoEquipamento.descricao}}</span></p>

          <!-- Transformador -->
          <section *ngIf="this.equipamento?.tipoDeEquipamentoId == 2" class="animated fadeInDown">

            <div class="form-row">

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="">Numero</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.numero" /> 
                </div>
              </div>
              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="">Potência</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.potencia" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="position-relative form-group">
                  <label for="">Tapos</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.taps" /> 
                </div>
              </div>

            </div>

            <div class="form-row">

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="">VP</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.vp" /> 
                </div>
              </div>

              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="">VS</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.vs" /> 
                </div>
              </div>

              <div class="col-md-6">
                <div class="position-relative form-group">
                  <label for="">Tombamento</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.tombamento" /> 
                </div>
              </div>

            </div>

          </section>


          <!-- Cabo Distribuição -->
          <section *ngIf="this.equipamento?.tipoDeEquipamentoId == 3" class="animated fadeInDown">

            <div class="form-row">

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="">Cabo</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.cabo" />
                </div>
              </div>

              <div class="col-md-8">
                <div class="position-relative form-group">
                  <label for="">Tipo de Cabo</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.tipo" />
                </div>
              </div>



            </div>

            <div class="form-row">

              <div class="col-md-5">
                <div class="position-relative form-group">
                  <label for="">Substação Origem</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.substacaoOrigem.codigo" />
                </div>
              </div>

              <div class="col-md-7">
                <div class="position-relative form-group">
                  <label for="">Substação Destino</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.substacaoDestino.codigo" />
                </div>
              </div>

            </div>


          </section>



          <!-- Elemento MP -->
          <section *ngIf="this.equipamento?.tipoDeEquipamentoId == 4" class="animated fadeInDown">

            <div class="form-row">
              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="">Quantidade</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.qtde" />
                </div>
              </div>
            </div>

          </section>

          <!-- Ativo Refrigeração  -->
          <section *ngIf="this.equipamento?.tipoDeEquipamentoId == 5" class="animated fadeInDown">

            <div class="form-row">

              <div class="col-md-2">
                <div class="position-relative form-group">
                  <label for="">Criticidade</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.criticidade" />
                </div>
              </div>
              <div class="col-md-10">
                <div class="position-relative form-group">
                  <label for="">Especificação</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.especificacao" />
                </div>
              </div>
            </div>

            <div class="form-row">

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="">Potência</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.potenciaAR" />
                </div>
              </div>

              <div class="col-md-4">
                <div class="position-relative form-group">
                  <label for="">Contorno</label>
                  <input class="form-control text-center" type="text" disabled [value]="this.equipamento?.contorno" />
                </div>
              </div>
            </div>
          </section>



        </section>


      </form>

















 
      
    </div>
    <div class="box-footer" style="padding: 3px;">
     
    </div>


  </div>

  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6">
          <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Fechar</button>
        </div>
      </div>
    </div>
  </div>


</ng-template>